export var REFERRAL_TYPES;
(function (REFERRAL_TYPES) {
    REFERRAL_TYPES["ADVISOR"] = "ADVISOR";
    REFERRAL_TYPES["EXTERNAL"] = "EXTERNAL";
    REFERRAL_TYPES["EMPLOYEE"] = "EMPLOYEE";
})(REFERRAL_TYPES || (REFERRAL_TYPES = {}));
